import {
    DELIVERYOPTION_SELECTED_NAME,
    ITEM_AVAILABILITY,
    BOPIS_ITEM_AVAILABILITY,
    STOP_OOS_STORE_TOOLTIP,
} from '../actionTypes/DeliveryOptionActionTypes';

export const deliveryOptionSelectedName = (selectedDeliveryOption) => ({
    type: DELIVERYOPTION_SELECTED_NAME,
    selectedDeliveryOption,
});

export const selectedItemAvailability = (selectedItemAvailability) => ({
    type: ITEM_AVAILABILITY,
    selectedItemAvailability,
});

export const selectedItemBopisAvailability = (selectedItemBopisAvailability) => ({
    type: BOPIS_ITEM_AVAILABILITY,
    selectedItemBopisAvailability,
});

export const stopOOSStoreTooltip = (payload) => ({
    type: STOP_OOS_STORE_TOOLTIP,
    payload,
});
